import { LocationInfo } from "../shared/models/Location";

export interface MapState {
  locations: Array<LocationInfo>;
  mapRef: google.maps.Map | null;
  query: string | null;
  regionalOperationCenter: boolean;
  selectedLocation: LocationInfo | null;
}

export const initialMapState: MapState = {
  locations: [],
  mapRef: null,
  query: null,
  regionalOperationCenter: false,
  selectedLocation: null
};
